import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

export default function useQueryMatch(
  queryValues: string[],
  key: string = 'section',
): boolean {
  const location = useLocation();
  const query = queryString.parse(location.search);

  return queryValues.includes(query[key]);
}
